export default __webpack_public_path__ + "static/media/forward1.f5c1751f.mp4";